module.exports = __webpack_public_path__ + "media/images/photoswipe/default-skin-0ff4d62150facee6b7dec616100ad3da.png";